/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResolveRecommendationsRequest {
    getFixupPrototypeFunction() { return ResolveRecommendationsRequest.fixupPrototype; }

    static newInstance(model: Partial<ResolveRecommendationsRequest>): ResolveRecommendationsRequest {
        let obj = Object.assign(new ResolveRecommendationsRequest(), model);
        ResolveRecommendationsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResolveRecommendationsRequest>): ResolveRecommendationsRequest {
        if (!model) return null;
        return ResolveRecommendationsRequest.newInstance(<ResolveRecommendationsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResolveRecommendationsRequest) {
        if (!obj) return;

        models.ResolveRecommendationsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResolveRecommendationsRequest): boolean {
        Object.setPrototypeOf(obj, ResolveRecommendationsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Action Name to resolve the recommendation
     */
    action_name: string;

    /**
     * Resource ID
     */
    resources: Array<string>;

    /**
     * Apply for all the resources.Allowed Values true or false
     */
    apply_for_all: boolean;

    /**
     * arguments to resolve action
     */
    args: any;

}
